<template>
	<div>
		<div class="border-top">
			<bar-info-actions
				:actions="services"
			></bar-info-actions>
			<div class="background-green"></div>
		</div>
		<div class="app-footer">
			<v-layout class="border-bottom" row wrap>
				<v-flex xs12 md3 sm12 class="text-center-mobile">
					<img src="/static/images-new/logos/logo-casamarket.svg" alt="" height="37" width="167">
					<div class="box-contact mt-4">
						<div>
							<img src="/static/images-new/logos/phone-footer.png" alt="" width="23" height="23">
						</div>
						<div class="ml-3">
							<p class="w-black fs-12 gray-cl m-0">AYUDA CALLCENTER</p>
							<span class="w-black fs-16 title-column">(+51) 9678567856</span>
						</div>
					</div>
					<v-flex xs12 md6 text-xs-center mb-3>
						<p class="w-black fs-12 gray-cl mt-3 mb-2">SÍGUENOS</p>
						<a href="">
							<img src="/static/images-new/logos/logo-fb-footer.svg" alt="" width="36" height="36">
						</a>
						<a href="">
							<img src="/static/images-new/logos/logo-ig-footer.svg" alt="" width="36" height="36">
						</a>
					</v-flex>
				</v-flex>
				<v-flex xs12 md9 sm12 class="text-center-mobile">
					<v-layout row wrap>
						<v-flex xs12 md4 sm12 mb-3 v-for="item in sections" :key="item.id">
							<p class="w-black title-column fs-16 mb-3">{{ item.name }}</p>
							<ul v-for="link in item.links" :key="link.id" class="list-style">
								<li class="mb-2">
									<a href="" class="href-depressed fs-13 gray-cl">
										{{ link.name }}
									</a>
								</li>
							</ul>
						</v-flex>
					</v-layout>
				</v-flex>
			</v-layout>
			<v-layout column class="gray-cl fs-13 mt-4">
				<v-flex xs12>
					COMPRAS 100% SEGURAS
				</v-flex>
				<v-flex xs12>
					Esta tienda online está autorizada por Visa para relizar transacciones electrónicas.
				</v-flex>
				<v-flex xs12>
					© 2020 CasaMarket Lima - Perú
				</v-flex>
			</v-layout>
		</div>
	</div>
</template>

<script>
import barInfoActions from '@/components/market-place/bar-info-actions';

export default {
	name: 'app-footer',
	components: {
		barInfoActions,
	},
	props: {
		sections: {
			type: Array,
			default: () => [],
		},
		services: {
			type: Array,
			default: () => [],
		},
	},
};
</script>

<style lang="scss" scoped>
.app-footer {
	background-color: color(newbackground);
	padding: 63px 129px 46px 129px;

	@media (max-width: 936px) {
		padding: 35px;
	}
}

.title-column {
	color: color(newwarning);
}

.gray-cl {
	color: color(gray-footer) !important;
}

.mb-2 {
	margin-bottom: 14px;
}

.list-style {
	list-style: none !important;
}

.border-bottom {
	border-bottom: 1px solid #dbdbdb;
	padding-bottom: 62px;

	@media (max-width: 936px) {
		padding-bottom: 20px;
	}
}

.box-contact {
	align-items: center;
	display: flex !important;

	@media (max-width: 936px) {
		justify-content: center;
	}
}

.m-0 {
	margin: 0;
}

.text-center-mobile {
	@media (max-width: 936px) {
		text-align: center;
	}
}

.section-services {
	display: flex;
	justify-content: space-around;
	margin: 0 242px;
	padding-top: 24px;

	@media (max-width: 936px) {
		align-items: center;
		flex-direction: column;
		margin: 0;
	}
}

.border-top {
	border-top: 1px solid #dbdbdb;
}

.mb-0 {
	margin-bottom: 0;
}

.box {
	align-items: center;
	display: flex;
	margin-bottom: 25px;
}

.background-green {
	background-color: #02979b;
	height: 26px;
}

.wdt-subtitle {
	@media (min-width: 936px) {
		width: 103px;	
	}
}
</style>


// WEBPACK FOOTER //
// src/components/market-place/app-footer.vue